import React, { FC, useState } from 'react'

import { Carousel } from 'mf-ui-components'

import { CarouselItem } from './CarouselItem'
import { LightCarouselSettings } from './types'
import { CarouselContainer } from './LightCarousel.styles'
import { mapEasingToFunction } from './mapEasingToFunction'
import { useParsedCarouselData } from './hooks'
import { DEFAULT_PROPS } from './data'
import { CarouselDots } from '../../../common/CarouselDots'
import { BaseBlockProps } from '../../../../types/BaseBlockProps'

type Props = {
  componentProps: string
} & LightCarouselSettings &
  BaseBlockProps

export const LightCarousel: FC<Props> = ({
  componentProps = JSON.stringify(DEFAULT_PROPS),
  hiddenAt,
  marginBottom,
  id,
}) => {
  const {
    slides,
    timePerSlide,
    transitionEasing,
    transitionDuration,
    autoScroll,
    imageShape,
  } = useParsedCarouselData(componentProps)

  const [autoPlay, setAutoPlaying] = useState<boolean>(autoScroll)

  if (!Array.isArray(slides)) return null

  return (
    <CarouselContainer id={id} hiddenAt={hiddenAt} marginBottom={marginBottom}>
      <Carousel
        wrapAround
        pauseOnHover
        autoplay={autoPlay}
        speed={transitionDuration}
        autoplayInterval={timePerSlide}
        easing={mapEasingToFunction(transitionEasing)}
        // TODO: Type properly.
        renderBottomCenterControls={({ currentSlide, goToSlide }: any) => (
          <CarouselDots
            amount={slides.length}
            current={currentSlide % slides.length}
            onClick={index => {
              goToSlide(index)

              // When manually selecting a slide, stop on it for twice the time
              // designated for a single slide during normal autplay, then
              // resume the autoplay.
              setAutoPlaying(false)

              setTimeout(() => setAutoPlaying(autoScroll), timePerSlide * 2)
            }}
          />
        )}
      >
        {slides.map(slide => (
          <CarouselItem key={slide.title} imageShape={imageShape} {...slide} />
        ))}
      </Carousel>
    </CarouselContainer>
  )
}
